/**
 * TenantMapPage — SAAS-TENANT-PORTAL-MAP-1.
 *
 * Página "Mapa" do portal do cliente (tenant_owner/tenant_admin/viewer). Mostra
 * os dispositivos do PRÓPRIO tenant no mapa. Reaproveita o DeviceMapPanel SEM
 * `tenantId` → o backend escopa por ctx.tenant_id (o request não manda tenant_id;
 * nunca X-Tenant), então cada tenant só vê a própria frota. super_admin, que
 * também enxerga este item, vê a frota global (mesma semântica de Dispositivos).
 */
import DeviceMapPanel from "../components/tenants/DeviceMapPanel.jsx";
import NavIcon from "../nav/NavIcon.jsx";

export default function TenantMapPage({ onNavigate }) {
  return (
    <div className="space-y-6">
      <header className="flex items-start gap-4 flex-wrap">
        <div className="flex-1 min-w-[12rem]">
          <div className="section-label mb-2">Frota da empresa</div>
          <h1 className="text-3xl font-semibold tracking-tight text-noc-text">Mapa dos dispositivos</h1>
          <p className="text-sm text-noc-muted mt-1">
            Localização e status dos equipamentos da sua empresa.
          </p>
        </div>
        {/* SAAS-COMPANIES-P2-PORTAL-POLISH — CTAs de navegação do portal */}
        <div className="flex gap-2">
          <button type="button" onClick={() => onNavigate?.("devices")}
            className="btn-ghost h-10 px-4 inline-flex items-center gap-2">
            <NavIcon name="device" size={15} />
            Ver dispositivos
          </button>
          <button type="button" onClick={() => onNavigate?.("claim-device")}
            className="btn-primary h-10 px-4 inline-flex items-center gap-2">
            <NavIcon name="qr" size={15} />
            Adicionar dispositivo
          </button>
        </div>
      </header>
      <DeviceMapPanel onNavigate={onNavigate} />
    </div>
  );
}
